<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.id"
                 placeholder="ID"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.userId"
                 placeholder="用户ID"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.clienId"
                 placeholder="客户端ID"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.ip"
                 placeholder="IP"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <DatePicker
              type="daterange"
              v-model="dateRange"
              placeholder="选择日期范围"
              style="width: 200px"
              @on-change="handleDateChange"
          ></DatePicker>
        </div>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
      </div>
    </div>
    <div class="table">
      <Table
          :columns="diyData.columns"
          :data="apiData.tableList"
      >
        <template slot="footer">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { apiUniqueVisitorList } from '@/api/unique-visitor.js'

export default {
  name: 'unique-visitor',
  data () {
    return {
      search: {
        id: '',
        userId: '',
        clienId: '',
        ip: '',
        pageNo: 1,
        pageSize: 10,
        dateBegin: '',
        dateEnd: ''
      },
      diyData: {
        columns: [
          {
            title: 'ID',
            width: '80px',
            key: 'id'
          },
          {
            title: '用户ID',
            width: '100px',
            key: 'userId'
          },
          {
            title: '用户昵称',
            width: '120px',
            key: 'nickname'
          },
          {
            title: '用户注册时间',
            width: '180px',
            key: 'userCreateTime'
          },
          {
            title: '客户端ID',
            width: '100px',
            key: 'clienId'
          },
          {
            title: 'IP',
            width: '150px',
            key: 'ip'
          },
          {
            title: '创建时间',
            width: '180px',
            key: 'createTime'
          },
          {
            title: '日期',
            width: '120px',
            key: 'date'
          }
        ]
      },
      apiData: {
        total: 0,
        tableList: []
      },
      dateRange: []
    }
  },
  methods: {
    pageChange (e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    searchFn () {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList () {
      this.$store.commit('setSpinShow', true)
      var opt = { ...this.search }
      apiUniqueVisitorList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data
        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    handleDateChange (dates) {
      if (dates.length === 2) {
        this.search.dateBegin = dates[0]
        this.search.dateEnd = dates[1]
      } else {
        this.search.dateBegin = ''
        this.search.dateEnd = ''
      }
    }
  },
  mounted () {
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
</style>
